module.exports = {
  deltaToMarkdown: require("./src/fromDelta")
};
